
import { Job } from "@/models/job";
import { JobService } from "@/services/job-service";
import { MainSocketService } from "@/services/main-socket-service";
import Vue from "vue";
import AppCreatePdfArchiveModalForm from "./CreatePdfArchiveModalForm.vue";
import AppCreatePdfArchiveModalProgress from "./CreatePdfArchiveModalProgress.vue";
import AppCreatePdfArchiveModalCreated from "./CreatePdfArchiveModalCreated.vue";
import { PdfS3UploadedFile } from "@/models/pdf-archive-file";
import { PdfArchiveService } from "@/services/pdf-archive-service";
import { BrowseState } from "@/utils/browse/browse-state";

interface IJobSub {
	event:string,
	handler:Function
}

export default Vue.extend({
	data(){
		return {
			state: "form" as "form" | "creating" | "done",
			jobSubs: [] as IJobSub[],
			job: null as null | Job,
			createdArchive: null as PdfS3UploadedFile | null,
		};
	},
	props: {
		browseState: {
			required: true,
			type: Object as () => BrowseState
		}
	},
	computed: {
		selectedSales(){
			return this.browseState.selectedItems.map((b) => b.ID);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async create(data:{beginDate:Date, endDate:Date, message:string}){
			try{
				this.state = "creating";
				let j = await PdfArchiveService.createArchive(data.beginDate, data.endDate, data.message,this.selectedSales);
				this.createdArchive = null;
				this.subToJob(`job-stopped/${j.getID()}`, this.onJobStopped);
				this.subToJob(`job-started/${j.getID()}`, this.onJobStarted);
				MainSocketService.on(`/pdfarchive/created-archive/${j.getID()}`, this.onArchiveCreated, this);
			}catch(err){
				this.state = "form";
			}
		},
		subToJob(event:string, handler:Function){
			JobService.on(event, handler);
			this.jobSubs.push({event, handler});
		},
		async onJobStopped(job:Job){
			if (this.createdArchive) return;
			if (job.Error != null) {
				this.state = "form";
			}
		},
		async onJobStarted(job:Job) {
			this.job = job;
		},
		async onArchiveCreated(archiveId:number){
			try{
				this.createdArchive = await PdfArchiveService.getArchive(archiveId);
				this.state = "done";
			}catch(err){
				this.state = "form";
			}
		},
	},
	mounted() {
	},
	destroyed(){
		for (let jobSub of this.jobSubs){
			JobService.off(jobSub.event, jobSub.handler);
		}
		MainSocketService.offAll(this);
	},
	components: {
		AppCreatePdfArchiveModalForm,
		AppCreatePdfArchiveModalProgress,
		AppCreatePdfArchiveModalCreated
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
